export const modelStockNoVinSearchPattern = /^[^[\]{}()!?$§=\\/|'"*+]*$/
